export default "__VITE_ASSET__DDNEx2Si__"